import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class VerifyPasswordGuard implements CanActivate {
  constructor(private router: Router) {}


  //wip
  canActivate(): boolean {
    const email = history.state?.email;
    if (email) {
      return true;
    } else {
      // this.router.navigate(['/authentication/login']);
      return false;
    }
  }
}